import type { ClientLegalDocument } from '../constants/clientLegalContent';
import { PlatformTermsBody } from './PlatformTermsBody';
import styles from './ClientLegalDocumentBody.module.css';

type ClientLegalDocumentBodyProps = {
  document: ClientLegalDocument;
  showHeading?: boolean;
};

export function ClientLegalDocumentBody({
  document,
  showHeading = false,
}: ClientLegalDocumentBodyProps) {
  if (document.sections?.length) {
    return (
      <PlatformTermsBody
        content={{
          heading: document.heading,
          intro: document.intro ?? '',
          sections: document.sections,
        }}
        showHeading={showHeading}
      />
    );
  }

  if (document.pdfUrl) {
    return (
      <div className={styles.root}>
        {showHeading ? <h4 className={styles.heading}>{document.heading}</h4> : null}
        {document.intro ? <p className={styles.intro}>{document.intro}</p> : null}
        <iframe
          className={styles.pdfFrame}
          src={document.pdfUrl}
          title={document.heading}
        />
      </div>
    );
  }

  return null;
}
